import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Phase 15 D-DS-03 — router-agnostic back link. The consumer wires `navigate`
 * from their router (Plan 04 injects useNavigate from the app's router package).
 * Keeps the design-system package free of router peerDependencies.
 *
 * Plan 04 JobDetailScreen calls this as:
 *   <BackLink to="/jobs" navigate={navigate} label="Back to jobs" />
 */
export function BackLink({ to, navigate, label, children }) {
    return (_jsxs("a", { href: to, className: "back-link", onClick: (e) => { e.preventDefault(); navigate(to); }, children: [_jsx("span", { className: "arr", children: "\u2190" }), _jsx("span", { children: children ?? label })] }));
}
//# sourceMappingURL=BackLink.js.map